module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [((_vm.consulta && _vm.consulta.tipo_status && _vm.consulta.tipo_status.id == 66) || (_vm.formData.tipo_status && _vm.formData.tipo_status.id == 66)) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "success",
      "description": 'Essa consulta foi LIBERADA em ' + _vm.formData.updated_at,
      "title": "Atenção"
    }
  })], 1) : ((_vm.consulta && _vm.consulta.tipo_status && (_vm.consulta.tipo_status.id == 57 || _vm.consulta.tipo_status.id == 58))) ? _c('div', {
    staticClass: "col-12 mb-4"
  }, [_c('ed-alert', {
    attrs: {
      "type": "error",
      "description": 'Essa consulta foi ' + _vm.consulta.tipo_status.descricao + ' em ' + _vm.toDate(_vm.consulta.updated_at) + '. Nenhuma alteração pode ser efetuada.',
      "title": "Atenção"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-4 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-arrow-left",
      "type": "primary",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.toRoute({
          name: 'credenciada.consulta'
        })
      }
    }
  })], 1)], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    staticClass: "col-12 mb-2"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "itens": _vm.formItems,
      "response": _vm.response
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "type": "success",
      "title": "Clique Aqui para salvar as alterações efetuadas",
      "value": "Salvar Alterações"
    },
    on: {
      "click": _vm.salvar
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1156a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/credenciada/consulta/configuracao/liberar.vue
// module id = 1448
// module chunks = 45